export class Instance {
    public id: string;
    public display: string;
    public domain: string;
    public proxy: string;
    public phone: string;
    public receptionist: string;
    public voicemail: string;
    public extensionsUrl: string;
    public provisionningUrl: string;
    public voiceUrl: string;
    public smsUrl: string;
    public audioUrl: string;
    public mailUrl: string;
    public features: Object;
}
